module.exports = __webpack_public_path__ + "img/rectangle-wide.d74a3a8c.svg";